<template>
    <div class="page newpage">
        <el-row>
            <el-col :span="9">
                <div id="myChart1" class="mt_30" style="margin:0 40px;height:400px;"></div>
            </el-col>
            <el-col :span="4">&nbsp;</el-col>
            <el-col :span="9">
                <div id="myChart2" class="mt_30" style="margin:0 40px;height:400px;"></div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="9">
                <div id="myChart3" class="mt_30" style="margin:0 40px;height:400px;"></div>
            </el-col>
            <el-col :span="4">&nbsp;</el-col>
            <el-col :span="9">
                <div id="myChart4" class="mt_30" style="margin:0 40px;height:400px;"></div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    import { userCount } from "@/request/apis.js"
    export default {
        data() {
            return {
                name: '',
                list: [],
                show: false,
                represShow: false,
                formData: {
                    name: ''
                }
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            async init() {
                var res = await userCount();
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }

                res.data.charts.forEach((ele, index) => {
                    echarts.init(document.getElementById('myChart' + (index + 1))).setOption({
                        title: { text: ele.name, left: 'left' },
                        tooltip: { trigger: 'item' },
                        legend: { orient: 'vertical', left: 'right' },
                        series: [
                            {
                                name: ele.name,
                                type: 'pie',
                                radius: ['40%', '70%'],
                                avoidLabelOverlap: false,
                                itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
                                label: { show: false, position: 'center' },
                                emphasis: { label: { show: true, fontSize: 20 } },
                                data: ele.items,
                                label: {
                                    show: true,
                                    formatter: '{b}: {@2019} ({d}%)'
                                },
                            }
                        ]
                    });
                });
            }
        }
    }
</script>

<style>
</style>